import React, { Component } from "react";
import calendar from "../images/calendar.svg";
import time from "../images/time.svg";
import eye from "../images/eyewhite.svg";
import edit from "../images/edit.svg";
import done from "../images/done.svg";
import CustomButton from "./CustomButton";
import moment from "moment-timezone";
import momentjalali from "moment-jalaali";
import { NumericFormat } from "react-number-format";
import { Icon } from "@iconify/react";
import infoIcon from "@iconify/icons-charm/info";
import { Modal } from "react-bootstrap";
import Cancel from "../images/cancel.svg";
import editOutlineSharp from "@iconify/icons-material-symbols/edit-outline-sharp";
import Loading from "./Loading";
import {
  BaseUrl,
  Authorization,
  LogoutFunction,
  ServerSocket,
  isUser,
} from "../static.js";
import twotoneKeyboardArrowLeft from "@iconify/icons-ic/twotone-keyboard-arrow-left";
import twotoneKeyboardArrowRight from "@iconify/icons-ic/twotone-keyboard-arrow-right";

export default class OrderItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: "",
      time: "",
      foods: "",
      infoModal: false,
      dataLoading: true,
      tabSelected: 1,
      currentVersion: this.props.item.version,
      currentOrder: null,
    };
  }

  componentDidMount() {
    var zone_name = moment.tz.guess();
    let newdatetime = moment
      .tz(this.props.datetime, zone_name)
      .format("yyyy-MM-DD HH:mm")
      .toString()
      .split(" ");
    newdatetime[0] = momentjalali(newdatetime[0]).format("jYYYY/jMM/jDD");
    let foods = "";
    this.props.items.forEach((element) => {
      if (foods === "")
        foods += element.foodName + " (×" + element.quantity + ")";
      else foods += ", " + element.foodName + " (×" + element.quantity + ")";
    });

    this.setState({ date: newdatetime[0], time: newdatetime[1], foods: foods });
  }

  viewClick() {
    this.props.onView(this.props.items);
  }

  editClick() {
    this.props.onEdit(
      this.props.id,
      this.props.orderStationId,
      this.props.items,
      this.props.item
    );
  }

  doneClick() {
    this.props.onDone(this.props.id);
  }

  showInfo() {
    this.setState({
      infoModal: true,
      tabSelected: 1,
    });
  }

  onTabClick(index) {
    this.setState({ tabSelected: index }, () => {
      if (index === 2)
        this.setState({ currentVersion: this.props.item.version }, () => {
          this.findOneOrder();
        });
    });
  }

  findOneOrder() {
    let data = {
      orderId: this.props.id,
      businessCode: this.props.businessCode,
      languageId: this.props.languageId,
      version: this.state.currentVersion,
    };
    console.log(data);
    data = Object.assign(data, Authorization());
    this.setState({ dataLoading: true });
    fetch(BaseUrl + "findOneOrder", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(
          "findOneOrder version " + this.state.currentVersion + ": ",
          result
        );
        if (result.status === 200) {
          this.setState({
            currentOrder: result.result,
            dataLoading: false,
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ dataLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  render() {
    return (
      <div className="orderItem">
        {this.props.item.isEdited === 1 && (
          <div
            style={{
              position: "absolute",
              right: "0px",
              top: "0px",
              width: "100%",
              height: "100%",
              overflow: "hidden",
              borderRadius: "10px",
              zIndex: "0",
            }}
          >
            <div
              style={{
                transform: "rotate(45deg)",
                backgroundColor: "var(--brown1)",
                minHeight: "40px",
                minWidth: "40px",
                position: "absolute",
                right: "-20px",
                top: "-20px",
              }}
            >
              <Icon
                icon={editOutlineSharp}
                width="9px"
                height="9px"
                color="white"
                style={{
                  position: "absolute",
                  bottom: "4px",
                  left: "calc(50% - 5px)",
                  transform: "rotate(-45deg)",
                }}
              />
              {/* <img
                src={edit}
                style={{
                  width: "5px",
                  height: "5px",
                  objectFit: "contain",
                  position: "absolute",
                  bottom: "5px",
                  left: "calc(50% - 8px)",
                  transform: "rotate(-45deg)",
                }}
                alt=""
              /> */}
            </div>
          </div>
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            zIndex: "1",
          }}
        >
          <div className="orderItemImgContainer">
            <img
              src={this.props.typeImg}
              alt=""
              className="orderItemImg"
              style={{ objectFit: "contain" }}
            />
            {this.props.item.prepareStatusTitle && (
              <div
                style={{
                  fontSize: "0.8em",
                  color: "var(--gray3)",
                  borderRadius: "20px",
                  padding: "5px",
                  border: "1px solid var(--gray3)",
                }}
              >
                {this.props.item.prepareStatusTitle}
              </div>
            )}
          </div>
          <div className="orderItemSpliter" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {this.props.item.id && (
              <div
                style={{
                  fontSize: "1em",
                  color: "var(--brown1)",
                  padding: "0px",
                  borderBottom: "1px solid var(--brown1)",
                  fontSize: "14px",
                }}
              >
                {this.props.item.id}
              </div>
            )}
            <div className="orderItemTitle">{this.props.title}</div>
            <Icon
              icon={infoIcon}
              width="16px"
              height="16px"
              onClick={this.showInfo.bind(this)}
              style={{ cursor: "pointer" }}
            />
          </div>
          {/* <div className="orderItemTitle">{this.props.orderId}</div> */}
          <div className="orderItemSpliter" />
          <div className="orderItemDesContainer">
            <div className="orderItemTimeContainer">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <img src={calendar} alt="" className="orderItemTimeImg" />
                {this.state.date}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <img src={time} alt="" className="orderItemTimeImg" />
                {this.state.time}
              </div>
            </div>
            <div className="orderItemDes">{this.state.foods}</div>
          </div>
          <div className="orderItemSpliter" />
          <div className="orderItemPrice">
            <NumericFormat
              allowNegative={true}
              value={this.props.price}
              displayType={"text"}
              thousandSeparator={true}
            />
            <div className="orderItemPriceUnit">{this.props.unit}</div>
          </div>
        </div>
        {this.props.item.status === 1 && (
          <div className="orderItemActionsContainer">
            {this.props.item.status === 1 &&
              this.props.subscriptionType !== 3 && (
                <div
                  style={{
                    width: "50%",
                  }}
                >
                  <CustomButton
                    direction="vertical"
                    title="ویرایش"
                    img={edit}
                    backColor="var(--brown4)"
                    onClick={this.editClick.bind(this)}
                  />
                </div>
              )}
            {this.props.item.status === 1 && <div style={{ width: "4px" }} />}
            {this.props.item.status === 1 && (
              <div
                style={{
                  width: "50%",
                }}
              >
                <CustomButton
                  direction="vertical"
                  title="تایید"
                  img={done}
                  backColor="var(--brown1)"
                  onClick={this.doneClick.bind(this)}
                />
              </div>
            )}
          </div>
        )}

        {((this.props.item.status === 2 && !isUser) ||
          this.props.item.status === 3) &&
          this.props.subscriptionType !== 3 && (
            <div className="orderItemActionsContainerOnWorking">
              <div
                style={{
                  width: "100%",
                }}
              >
                <CustomButton
                  direction="vertical"
                  title="ویرایش"
                  img={edit}
                  backColor="var(--brown4)"
                  onClick={this.editClick.bind(this)}
                />
              </div>
            </div>
          )}

        <Modal
          show={this.state.infoModal}
          animation={false}
          onHide={() => {
            this.setState({ infoModal: false });
          }}
          centered
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              padding: "10px 20px",
            }}
          >
            <div className="orderTabsContainer" style={{ margin: "0" }}>
              <div
                className={
                  this.state.tabSelected === 1
                    ? "orderTab orderTabSelected"
                    : "orderTab orderTabUnSelected"
                }
                onClick={this.onTabClick.bind(this, 1)}
              >
                اطلاعات کلی
              </div>
              {this.props.item.version && this.props.item.version > 1 && (
                <div
                  className={
                    this.state.tabSelected === 2
                      ? "orderTab orderTabSelected"
                      : "orderTab orderTabUnSelected"
                  }
                  onClick={this.onTabClick.bind(this, 2)}
                >
                  سوابق تغییرات
                </div>
              )}
            </div>
            {(this.state.tabSelected === 1 ||
              !this.props.item.version ||
              this.props.item.version < 2) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    width: "90%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                    margin: "15px 0px",
                    marginTop: "30px",
                  }}
                >
                  <div>شماره فاکتور:</div>
                  <div>{this.props.item.id}</div>
                </div>

                <div
                  style={{
                    width: "90%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                    margin: "12px 0px",
                  }}
                >
                  <div>نام مشتری:</div>
                  <div>
                    {this.props.item.customerFullName
                      ? this.props.item.customerFullName
                      : "-"}
                  </div>
                </div>

                <div
                  style={{
                    width: "90%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                    margin: "12px 0px",
                  }}
                >
                  <div>موبایل مشتری:</div>
                  <div style={{ direction: "ltr" }}>
                    {this.props.item.customerMobile
                      ? this.props.item.customerMobile
                      : "-"}
                  </div>
                </div>
              </div>
            )}

            {this.state.tabSelected === 2 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  alignItems: "center",
                  marginTop: "30px",
                }}
              >
                <Icon
                  icon={twotoneKeyboardArrowRight}
                  style={{
                    fontSize: "50px",
                    cursor:
                      this.state.currentVersion > 1 ? "pointer" : "default",
                    color:
                      this.state.currentVersion > 1
                        ? "var(--black1)"
                        : "var(--gray3)",
                  }}
                  onClick={() => {
                    if (this.state.currentVersion > 1)
                      this.setState(
                        {
                          currentVersion: this.state.currentVersion - 1,
                        },
                        () => {
                          this.findOneOrder();
                        }
                      );
                  }}
                />
                <div
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    border: "2px solid var(--black1)",
                    borderRadius: "10px",
                    padding: "10px 20px",
                    userSelect: "none",
                  }}
                >
                  {this.state.currentVersion}
                </div>
                <Icon
                  icon={twotoneKeyboardArrowLeft}
                  style={{
                    fontSize: "50px",
                    cursor:
                      this.state.currentVersion < this.props.item.version
                        ? "pointer"
                        : "default",
                    color:
                      this.state.currentVersion < this.props.item.version
                        ? "var(--black1)"
                        : "var(--gray3)",
                  }}
                  onClick={() => {
                    if (this.state.currentVersion < this.props.item.version)
                      this.setState(
                        {
                          currentVersion: this.state.currentVersion + 1,
                        },
                        () => {
                          this.findOneOrder();
                        }
                      );
                  }}
                />
              </div>
            )}

            {this.state.dataLoading && this.state.tabSelected === 2 && (
              <div
                style={{
                  minHeight:
                    this.state.currentOrder && this.state.currentOrder.items
                      ? this.state.currentOrder.items.length * 55 + 39
                      : "150px",
                  width: "100%",
                  marginTop: "20px",
                  position: "relative",
                }}
              >
                <Loading size={30} />
              </div>
            )}

            {this.state.tabSelected === 2 &&
              this.props.item.version &&
              !this.state.dataLoading &&
              this.state.currentOrder &&
              this.state.currentOrder.items.length === 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "20px",
                    minHeight: "120px",
                  }}
                >
                  سفارش در این مرحله ابطال گردیده است
                </div>
              )}

            {this.state.tabSelected === 2 &&
              this.props.item.version &&
              this.props.item.version > 1 &&
              !this.state.dataLoading &&
              this.state.currentOrder &&
              this.state.currentOrder.items.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "20px",
                  }}
                >
                  <div
                    style={{
                      width: "90%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "row",
                      // marginTop: "40px",
                      borderBottom: "2px solid var(--black1)",
                      fontSize: "18px",
                      fontWeight: "bold",
                      paddingBottom: "10px",
                      // userSelect: "none",
                    }}
                  >
                    <div>نام محصول</div>
                    <div>تعداد</div>
                  </div>
                  {this.state.currentOrder.items.map((item, i) => (
                    <div style={{ width: "90%" }} key={i}>
                      <div
                        style={{
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "row",
                          margin: "15px 0px",
                        }}
                      >
                        <div>{item.foodName}</div>
                        <div
                          style={{
                            direction: "ltr",
                            minWidth: "35px",
                            textAlign: "center",
                          }}
                        >
                          {item.quantity}
                        </div>
                      </div>
                      <div
                        style={{
                          backgroundColor: "var(--black2)",
                          width: "100%",
                          minHeight: "1px",
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}

            <div style={{ width: "90%", marginTop: "40px" }}>
              <CustomButton
                title="انصراف"
                imgHeight={19}
                backColor="var(--black1)"
                imgWidth={25}
                minHeight="35px"
                img={Cancel}
                onClick={() => {
                  this.setState({ infoModal: false });
                }}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
